/* House defaults for the board's category taxonomy — the Office can rewrite the
   list anytime (saved server-side); these are the fallback until the fetch lands. */

export const DEFAULT_CATEGORY_LIST = [
  { name: "Fashion Model", color: "#C8102E" },
  { name: "Actor", color: "#4C8DFF" },
  { name: "Photographer", color: "#9C7BFF" },
  { name: "Commercial", color: "#E8A33D" },
  { name: "Runway", color: "#3DDC97" },
  { name: "Editorial", color: "#FF6B9D" },
  { name: "Film & TV", color: "#56CFE1" },
  { name: "Music Video", color: "#FFD166" },
  { name: "Fitness", color: "#64DF8A" },
  { name: "Influencer", color: "#F4845F" },
  { name: "Hair & Beauty", color: "#E5B8F4" },
  { name: "Dancer", color: "#7BDFF2" },
];

export const DEFAULT_CATEGORY_NAMES = DEFAULT_CATEGORY_LIST.map((c) => c.name);
export const DEFAULT_CATEGORY_COLORS = Object.fromEntries(DEFAULT_CATEGORY_LIST.map((c) => [c.name, c.color]));
